import React, { Component } from 'react'
import axios from 'axios'
import CurrencyFormat from 'react-currency-format'

import { reactLocalStorage } from 'reactjs-localstorage'
import { toast } from 'react-toastify'

import { serverUrl, headerRequest } from '../../lib/funApp/general'

import { Modal, Card } from 'react-bootstrap'
import { Button, Icon } from 'semantic-ui-react'
import { FormControl, InputLabel, MenuItem, Select, TextField, Grid } from '@material-ui/core'

export default class AccountBalanceAdjust extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      loading: false,
      accountId: '',
      balance: 0,
    }
  }

  handleToggle = () => {
    const willOpen = !this.state.show
    if (!willOpen) {
      this.setState({ show: false, loading: false })
      return
    }

    const accounts = Array.isArray(this.props.accounts) ? this.props.accounts : []
    const first = accounts.length > 0 ? accounts[0] : null

    this.setState({
      show: true,
      loading: false,
      accountId: first ? first._id : '',
      balance: first ? Number(first.balance || 0) : 0,
    })
  }

  handleChangeAccount = (event) => {
    const accountId = event.target.value
    const accounts = Array.isArray(this.props.accounts) ? this.props.accounts : []
    const selected = accounts.find((item) => String(item._id) === String(accountId))
    this.setState({
      accountId,
      balance: selected ? Number(selected.balance || 0) : 0,
    })
  }

  handleChangeBalance = (values) => {
    const nextValue = values && typeof values.floatValue === 'number' ? values.floatValue : 0
    this.setState({ balance: nextValue })
  }

  handleSubmit = () => {
    if (!this.state.accountId) {
      toast.error('Selecione a conta.')
      return
    }

    const nextBalance = Number(this.state.balance)
    if (!Number.isFinite(nextBalance)) {
      toast.error('Informe um saldo válido.')
      return
    }

    this.setState({ loading: true })

    axios
      .patch(
        `${serverUrl}/src/accounts/${this.state.accountId}`,
        { balance: nextBalance },
        { headers: headerRequest }
      )
      .then((res) => {
        if (res.status === 200) {
          reactLocalStorage.set('@result', 201)
          setTimeout(() => window.location.reload(false), 400)
        }
      })
      .catch((error) => {
        this.setState({ loading: false })
        toast.error('Erro ao ajustar saldo da conta.')
        console.log(error.response || error)
      })
  }

  render() {
    const accounts = Array.isArray(this.props.accounts) ? this.props.accounts : []

    return (
      <>
        <Button icon labelPosition="left" color="teal" size="small" onClick={this.handleToggle}>
          Ajustar Saldo
          <Icon name="balance scale" />
        </Button>

        <Modal show={this.state.show} onHide={this.handleToggle} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <Icon name="balance scale" className="mr-2" />
              Ajustar saldo da conta
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card>
              <Card.Body>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormControl className="w-100">
                      <InputLabel id="adjust-account-label">Conta</InputLabel>
                      <Select
                        labelId="adjust-account-label"
                        id="adjust-account"
                        value={this.state.accountId}
                        onChange={this.handleChangeAccount}
                      >
                        {accounts.map((account) => (
                          <MenuItem key={account._id} value={account._id}>
                            {account.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <CurrencyFormat
                      label="Novo saldo"
                      value={this.state.balance}
                      onValueChange={this.handleChangeBalance}
                      thousandSeparator="."
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale={2}
                      prefix="R$ "
                      customInput={TextField}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Card.Body>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button negative onClick={this.handleToggle}>
              Cancelar
            </Button>
            <Button
              positive
              onClick={this.handleSubmit}
              disabled={this.state.loading || accounts.length === 0}
            >
              {!this.state.loading ? 'Salvar saldo' : 'Salvando...'}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}
